import React, { useEffect } from 'react';
import { PictureSources, ViewsModels } from 'features/reviews';
import { Breakpoint } from 'types/utils';
import { ReviewCard } from './review-card';
import { ReviewsShowMoreButton } from './show-more-button';
import { ReviewsPaginationPageSkeleton, ReviewsShowMoreButtonSkeleton } from './skeletons';
import { extractReviewsOpinion } from './utils';
import { showNotification } from '@navi-toolbox/ui-components';
import { NotificationTemplates } from 'common/components/notification-template-factory/types';

export const ReviewsPaginationTail: React.FC<{
  paginationError: string | null;
  paginationTail: ViewsModels.ReviewsPaginationPage[];
  paginationPageIsLoading: boolean;
  breakpoint: Breakpoint;
  reviewsOpinions: ViewsModels.ReviewsOpinionRecords[];
  fetchNext: (currentPage: number) => void;
  onShowPicture: (pic: PictureSources | null) => void;
  onLike: (reviewsId: string) => void;
  onCancelLike: (reviewsId: string) => void;
  onCancelDislike: (reviewsId: string) => void;
  onDislike: (reviewsId: string) => void;
  onChangeDislikeToLike: (reviewsId: string) => void;
  onChangeLikeToDislike: (reviewsId: string) => void;
}> = ({
  breakpoint,
  paginationError,
  paginationTail,
  paginationPageIsLoading,
  reviewsOpinions,
  fetchNext,
  onShowPicture,
  onLike,
  onDislike,
  onCancelLike,
  onCancelDislike,
  onChangeDislikeToLike,
  onChangeLikeToDislike,
}) => {
  const lastPage = paginationTail[paginationTail.length - 1] || null;
  const currentPage = paginationTail.length + 1;
  const showLoadNext =
    !paginationPageIsLoading &&
    (lastPage === null || lastPage.pageMeta.totalPages > lastPage.pageMeta.currentPage);

  const extractedReviewOpinion = extractReviewsOpinion(reviewsOpinions);

  useEffect(() => {
    if (paginationError) {
      showNotification({
        templateId: NotificationTemplates.ReviewsError,
      });
    }
  }, [paginationError]);

  return (
    <>
      {paginationTail.map((pg, id) => (
        <div key={id}>
          {pg.reviewsCards.map((reviewData) => {
            const reviewOpinion = extractedReviewOpinion(reviewData.reviewId);
            return (
              <ReviewCard
                breakpoint={breakpoint}
                key={reviewData.reviewId}
                reviewData={reviewData}
                onShowPicture={onShowPicture}
                reviewOpinion={reviewOpinion}
                onLike={onLike}
                onDislike={onDislike}
                onCancelLike={onCancelLike}
                onCancelDislike={onCancelDislike}
                onChangeDislikeToLike={onChangeDislikeToLike}
                onChangeLikeToDislike={onChangeLikeToDislike}
              />
            );
          })}
        </div>
      ))}

      {paginationPageIsLoading && <ReviewsPaginationPageSkeleton />}

      {showLoadNext && <ReviewsShowMoreButton fetchNext={() => fetchNext(currentPage)} />}

      {paginationPageIsLoading && <ReviewsShowMoreButtonSkeleton />}
    </>
  );
};
